module.exports = __webpack_public_path__ + "img/phone_in_talk.8f4d8ed9.svg";